<template>
  <div class="dashboard-widget-header">
    <img
      v-if="icon"
      :src="icon.url"
      role="presentation"
      class="widget-icon"
      alt=""
    >
    <span class="title">{{ title }}</span>
    <div
      v-if="showClose"
      class="close"
      @click="remove()"
    >
      <icon
        name="cross"
      />
    </div>
    <span
      v-if="totalItemsCount > 0"
      class="item-counts"
    >
      <template v-if="showFreeCounts">
        <span class="free">{{ freeItemsCount }} Free</span> of
      </template>
      {{ totalItemsCount }} {{ totalDisplayName }}
    </span>
    <button
      v-if="postHeaderIcon"
      class="post-header-icon-button"
      @click="$emit('post-header-icon-click')"
    >
      <icon
        class="post-header-icon"
        :name="postHeaderIcon.name"
        :variant="postHeaderIcon.variant"
      />
    </button>
    <span
      v-if="subtitle"
      class="subtitle"
    >{{ subtitle }}</span>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
export default {
  components: { Icon },
  props: {
    freeItemsCount: {
      type: Number,
    },
    icon: {
      type: Object,
    },
    postHeaderIcon: {
      type: Object,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    showFreeCounts: {
      type: Boolean,
    },
    subtitle: {
      type: String,
    },
    totalDisplayName: {
      type: String,
    },
    totalItemsCount: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
    },
  },
  methods: {
    remove() {
      this.$emit('remove-requested');
    },
  },
};
</script>

<style lang='scss' scoped>
.dashboard-widget-header {
  margin-bottom: rem-calc(16);
  margin-right: auto;

  .title {
    font-family: 'Inter', sans-serif !important;
    font-size: rem-calc(18) !important;
    line-height: rem-calc(24);
    font-weight: $bold;
  }

  .widget-icon {
    margin-right: rem-calc(6);
    width: rem-calc(16);
  }

  .item-counts {
    display: none;
  }

  .subtitle {
    display: block;
    font-size: rem-calc(12);
    margin: rem-calc(8) 0 0 0;
    padding: 0;
    font-weight: $semi-bold;
    color: #767676;
  }

  .post-header-icon-button {
    background: transparent;
    border: none;
    padding: 0;
    margin-left: rem-calc(16);

    .post-header-icon {
      width: rem-calc(16);
    }
  }
  .close {
    border: 0;
    cursor: pointer;
    display: inline;
    filter: invert(67%) sepia(20%) saturate(9%) hue-rotate(320deg) brightness(89%) contrast(80%);

    img {
      height: rem-calc(24);
      width: rem-calc(24);
    }
  }
}
</style>
